<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    <fieldset>
      <legend>
        {{ $t('Select your business entity type') }}
      </legend>

      <DeBusinessEntityTypeRadioGroup v-model="businessEntityType" name="business_entity" />
    </fieldset>

    <fieldset v-if="hasSelectedValidBusinessEntityType">
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <DeBusinessEntityDetailsForm
        v-model:business-entity="internalBusinessEntity"
        :compliance-data="complianceData"
      />
    </fieldset>

    <SubmitButton :text="$t('Save')" auto-submit class="m-t-20" />
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import SubmitButton from '@/components/SubmitButton.vue'
import DeBusinessEntityDetailsForm from '@/components/compliances/BusinessEntity/De/DeBusinessEntityDetailsForm.vue'
import DeBusinessEntityTypeRadioGroup from '@/components/compliances/BusinessEntity/De/DeBusinessEntityTypeRadioGroup.vue'

export default {
  name: 'FreelancerDeBusinessEntityForm',

  components: {
    DeBusinessEntityDetailsForm,
    DeBusinessEntityTypeRadioGroup,
    SubmitButton,
  },

  props: {
    businessEntity: {
      type: Object,
      required: true,
    },

    complianceData: {
      type: Object,
      required: true,
    },

    freelancer: {
      type: Object,
      required: true,
    },
  },

  emits: ['update:businessEntity'],

  setup(props, { emit }) {
    const internalBusinessEntity = ref(props.businessEntity)

    const businessEntityType = computed({
      get() {
        return internalBusinessEntity.value.entityType
      },

      set(value) {
        internalBusinessEntity.value.entityType = value
        emit('update:businessEntity', this.internalBusinessEntity)
      },
    })

    const hasSelectedValidBusinessEntityType = computed(() =>
      ['de_freelancer', 'de_tradesperson', 'de_entrepreneurial', 'de_limited'].includes(
        businessEntityType.value,
      ),
    )

    return {
      businessEntityType,
      hasSelectedValidBusinessEntityType,
      internalBusinessEntity,
    }
  },
}
</script>
